/**
 * Parse the search term without the specified mimir media type.
 * @param {string|undefined} searchTerm
 * @returns {string}
 */
export function parseSearchTextWithoutType(searchTerm) {
  return searchTerm?.replace(/type:(image|video).*/, '').trim();
}
